// Build-time feature flags. Flipping one of these is a one-word change.
//
// dimop: the Hungarian DIMOP Plusz landing page at /hu/dimop. While true the
// route exists for /hu only (/dimop and /sr/dimop 404), the page is prerendered
// and listed in the sitemap and llms.txt as Hungarian only, and the Hungarian
// footer links to it. While false the URL 404s and nothing links to it.
// scripts/prerender.mjs and scripts/build-seo.mjs read this line with a regex.
export const DIMOP_ENABLED = true;

// Self-hosted, cookieless analytics (Umami) - see docs/analytics.md.
// Empty string = analytics off. Paste the website ID from the Umami dashboard
// (Settings -> Websites -> Edit) to turn it on. It is not a secret.
export const UMAMI_WEBSITE_ID = "26150a30-0c51-428c-b73a-52663bb99ebd";
